import { createSelector } from 'reselect';
import { usePromotionsSelector } from '../../store';
import { PromotionsApi, PromotionsState } from '../../types';

export const selectPromoById = (promoId: string) =>
  createSelector(
    (state: PromotionsState) => state.promotions,
    (promotions: PromotionsApi) =>
      promotions.find((promo) => promo.promoId === promoId)
  );

export const usePromoById = (promoId: string) =>
  usePromotionsSelector(selectPromoById, [promoId]);
